import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "m11.048 10.006 5.181-5.18a.622.622 0 1 0-.881-.882l-5.181 5.181-5.188-5.187a.622.622 0 1 0-.881.88L9.279 10l-5.181 5.188a.622.622 0 1 0 .881.88l5.181-5.18 5.182 5.18a.67.67 0 0 0 .45.182.622.622 0 0 0 .437-1.062z"
    }, null, -1)
  ]))]))
}
export default { render: render }